<template>
    <div :data-visible="visible" class="image-gallery">
        <div
            v-for="(image, index) in imagesToShow"
            :key="image.small"
            class="image"
        >
            <a :href="image.large" @click.prevent="openImage(index)">
                <div :style="{ backgroundImage: `url(${image.small})` }" class="img">
                    <div v-if="index === (visible - 1) && images.length > imagesToShow.length" class="additional-image-count">
                        <i class="icons8-google-images-filled"/> <span>+{{ images.length - imagesToShow.length }}</span>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import 'magnific-popup';
    import '../../../less/components/vendor/magnific-popup.less';

    export default {
        name: 'image-gallery',

        props: {
            images: {
                type: Array,
                default() {
                    return [];
                },
            },

            visible: {
                type: Number,
                default() {
                    return 2;
                },
            },
        },

        computed: {
            imagesToShow() {
                return this.images.slice(0, this.visible);
            },

            magnificPopupItems() {
                return this.images.map(image => ({ src: image.large }));
            },
        },

        methods: {
            openImage(index) {
                $.magnificPopup.open({
                    items: this.magnificPopupItems,
                    type: 'image',
                    image: {
                        verticalFit: true,
                        cursor: '.mfp-pointer-cur',
                    },
                    gallery: {
                        enabled: true,
                    },
                }, index);
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~assets/less/components/mixins/helpers.less";
    @import (reference) "~bootstrap/less/mixins/clearfix.less";
    @import (reference) "~bootstrap/less/mixins/grid.less";

    .image-gallery {
        .clearfix;
        overflow: hidden;
        .make-row(11px);
        &[data-visible='3'] {
            .image {
                .make-xs-column(4, 11px);
            }
        }
        .image {
            .make-xs-column(6, 11px);
            a {
                &:hover {
                    .img {
                        opacity: 0.9;
                        transform: scale(0.975);
                    }
                }
                .img {
                    border-radius: 4px;
                    background-color: @YPS-primary;
                    padding-bottom: 60%;
                    position: relative;
                    color: #ffffff;
                    opacity: 1;
                    transform: scale(1);
                    transition: 0.15s ease-in;
                    .bg-cover;
                    background-position: center;
                }
            }
        }
        .additional-image-count {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 700;
            span {
                text-decoration: underline;
            }
        }
    }
</style>
